import React from 'react';
import { DatePicker } from 'antd';
import { object, string, func } from 'prop-types';

import {
  FormItem,
  QuillTextWrap,
  MeetingNoteInfoWrap,
  MeetingInfoDateTimeWrap,
  MeetingInfoDateTimeItem,
} from './styles';

import { TimePicker } from '../../components/ui-helpers/';

import { disabledFutureDays } from '../../utils';
import { ReactQuillWrapped } from '../../components/react-quill';

export const MeetingNoteInfo = (props) => {
  const {
    date,
    text,
    meetingInfo,
    time,
    onTextChange,
    onMeetingInfoChange,
    onDateChange,
    onTimeChange,
    form: { getFieldDecorator },
  } = props;

  return (
    <MeetingNoteInfoWrap id="meetingNoteInfo">
      <QuillTextWrap>
        <label>Text notes:</label>
        <ReactQuillWrapped
          height="400px"
          withPaddings
          onChange={onTextChange}
          placeholder="Write a note here"
          theme="snow"
          value={text}
          bounds="#meetingNoteInfo"
          scrollingContainer="#meetingNoteInfo"
        />
      </QuillTextWrap>
      <QuillTextWrap>
        <label>Additional info:</label>
        <ReactQuillWrapped
          height="100px"
          withPaddings
          onChange={onMeetingInfoChange}
          placeholder="Add info here"
          label="Hey"
          theme="snow"
          value={meetingInfo}
          bounds="#meetingNoteInfo"
          scrollingContainer="#meetingNoteInfo"
        />
      </QuillTextWrap>

      <MeetingInfoDateTimeWrap>
        <MeetingInfoDateTimeItem>
          <span>Choose a date</span>
          <FormItem>
            {getFieldDecorator('date', {
              initialValue: date,
              rules: [
                {
                  required: true,
                  message: 'Please choose date',
                },
              ],
            })(<DatePicker
              format="DD/MM/YYYY"
              onChange={onDateChange}
              disabledDate={disabledFutureDays}
            />)}
          </FormItem>
        </MeetingInfoDateTimeItem>

        <MeetingInfoDateTimeItem>
          <span>Choose a time</span>
          <TimePicker use12Hours format="h:mm a" defaultValue={time} onChange={onTimeChange} />
        </MeetingInfoDateTimeItem>
      </MeetingInfoDateTimeWrap>
    </MeetingNoteInfoWrap>
  );
};

MeetingNoteInfo.propTypes = {
  date: object,
  time: object,
  form: object.isRequired,
  text: string.isRequired,
  meetingInfo: string.isRequired,
  onTextChange: func.isRequired,
  onMeetingInfoChange: func.isRequired,
  onDateChange: func.isRequired,
  onTimeChange: func.isRequired,
};

MeetingNoteInfo.defaultProps = {
  date: null,
  time: null,
};



// WEBPACK FOOTER //
// ./src/modals/meeting-notes-modal/meeting-note-info.js